import {
  CRUD_CONTRACT_CRM_TEAM,
  GET_CONTRACT_CRM_TEAM_BY_CONTRACT_ID,
  CRUD_ACCOUNT_CRM_TEAM,
  GET_ACCOUNT_CRM_TEAM_BY_ACCOUNT_ID,
  CRUD_OPPORTUNITY_CRM_TEAM,
  GET_OPPORTUNITY_CRM_TEAM_BY_OPPORTUNITY_ID,
  CRUD_CONTACT_CRM_TEAM,
  GET_CONTACT_CRM_TEAM_BY_CONTACT_ID,
  CRUD_LEAD_CRM_TEAM,
  GET_LEAD_CRM_TEAM_BY_LEAD_ID,
  CRUD_CAMPAIGN_CRM_TEAM,
  GET_CAMPAIGN_CRM_TEAM_BY_CAMPAIGN_ID,
  CRUD_INQUIRY_CRM_TEAM,
  GET_INQUIRY_CRM_TEAM_BY_INQUIRY_ID,
  CRUD_PROSPECT_CRM_TEAM,
  GET_PROSPECT_CRM_TEAM_BY_PROSPECT_ID,
  CRUD_CUSTOMER_CRM_TEAM,
  GET_CUSTOMER_CRM_TEAM_BY_CUSTOMER_ID,
  CRUD_ORDER_CRM_TEAM,
  GET_ORDER_CRM_TEAM_BY_ORDER_ID,
} from "@routes";
import {
  // Contract
  addContractCrmTeam,
  getContractCrmTeam,
  updateContractCrmTeam,
  deleteContractCrmTeam,

  // Account
  addAccountCrmTeam,
  getAccountCrmTeam,
  updateAccountCrmTeam,
  deleteAccountCrmTeam,

  // Opportunity
  addOpportunityCrmTeam,
  getOpportunityCrmTeam,
  updateOpportunityCrmTeam,
  deleteOpportunityCrmTeam,

  // Contact
  addContactCrmTeam,
  getContactCrmTeam,
  updateContactCrmTeam,
  deleteContactCrmTeam,

  // Lead
  addLeadCrmTeam,
  getLeadCrmTeam,
  updateLeadCrmTeam,
  deleteLeadCrmTeam,

  // Campaign
  addCampaignCrmTeam,
  getCampaignCrmTeam,
  updateCampaignCrmTeam,
  deleteCampaignCrmTeam,

  // Inquiry
  addInquiryCrmTeam,
  getInquiryCrmTeam,
  updateInquiryCrmTeam,
  deleteInquiryCrmTeam,

  // Prospect
  addProspectCrmTeam,
  getProspectCrmTeam,
  updateProspectCrmTeam,
  deleteProspectCrmTeam,

  // Customer
  addCustomerCrmTeam,
  getCustomerCrmTeam,
  updateCustomerCrmTeam,
  deleteCustomerCrmTeam,

  // Order
  addOrderCrmTeam,
  getOrderCrmTeam,
  updateOrderCrmTeam,
  deleteOrderCrmTeam,
} from "./crmTeamSlice";

// Lazy getter function for CRM Team API map
export const getCrmTeamApiMap = () => ({
  contract: {
    entityType: "contract",
    idKey: "contractId",
    get: getContractCrmTeam,
    add: addContractCrmTeam,
    update: updateContractCrmTeam,
    delete: deleteContractCrmTeam,
    endpoints: {
      get: GET_CONTRACT_CRM_TEAM_BY_CONTRACT_ID,
      add: CRUD_CONTRACT_CRM_TEAM,
      update: CRUD_CONTRACT_CRM_TEAM,
      delete: CRUD_CONTRACT_CRM_TEAM,
    },
  },
  "customer-account": {
    entityType: "customer-account",
    idKey: "customerAccountId",
    get: getAccountCrmTeam,
    add: addAccountCrmTeam,
    update: updateAccountCrmTeam,
    delete: deleteAccountCrmTeam,
    endpoints: {
      get: GET_ACCOUNT_CRM_TEAM_BY_ACCOUNT_ID,
      add: CRUD_ACCOUNT_CRM_TEAM,
      update: CRUD_ACCOUNT_CRM_TEAM,
      delete: CRUD_ACCOUNT_CRM_TEAM,
    },
  },
  account: {
    entityType: "customer-account",
    idKey: "customerAccountId",
    get: getAccountCrmTeam,
    add: addAccountCrmTeam,
    update: updateAccountCrmTeam,
    delete: deleteAccountCrmTeam,
    endpoints: {
      get: GET_ACCOUNT_CRM_TEAM_BY_ACCOUNT_ID,
      add: CRUD_ACCOUNT_CRM_TEAM,
      update: CRUD_ACCOUNT_CRM_TEAM,
      delete: CRUD_ACCOUNT_CRM_TEAM,
    },
  },
  opportunity: {
    entityType: "opportunity",
    idKey: "opportunityId",
    get: getOpportunityCrmTeam,
    add: addOpportunityCrmTeam,
    update: updateOpportunityCrmTeam,
    delete: deleteOpportunityCrmTeam,
    endpoints: {
      get: GET_OPPORTUNITY_CRM_TEAM_BY_OPPORTUNITY_ID,
      add: CRUD_OPPORTUNITY_CRM_TEAM,
      update: CRUD_OPPORTUNITY_CRM_TEAM,
      delete: CRUD_OPPORTUNITY_CRM_TEAM,
    },
  },
  contact: {
    entityType: "contact",
    idKey: "contactId",
    get: getContactCrmTeam,
    add: addContactCrmTeam,
    update: updateContactCrmTeam,
    delete: deleteContactCrmTeam,
    endpoints: {
      get: GET_CONTACT_CRM_TEAM_BY_CONTACT_ID,
      add: CRUD_CONTACT_CRM_TEAM,
      update: CRUD_CONTACT_CRM_TEAM,
      delete: CRUD_CONTACT_CRM_TEAM,
    },
  },
  lead: {
    entityType: "lead",
    idKey: "leadId",
    get: getLeadCrmTeam,
    add: addLeadCrmTeam,
    update: updateLeadCrmTeam,
    delete: deleteLeadCrmTeam,
    endpoints: {
      get: GET_LEAD_CRM_TEAM_BY_LEAD_ID,
      add: CRUD_LEAD_CRM_TEAM,
      update: CRUD_LEAD_CRM_TEAM,
      delete: CRUD_LEAD_CRM_TEAM,
    },
  },
  campaign: {
    entityType: "campaign",
    idKey: "campaignId",
    get: getCampaignCrmTeam,
    add: addCampaignCrmTeam,
    update: updateCampaignCrmTeam,
    delete: deleteCampaignCrmTeam,
    endpoints: {
      get: GET_CAMPAIGN_CRM_TEAM_BY_CAMPAIGN_ID,
      add: CRUD_CAMPAIGN_CRM_TEAM,
      update: CRUD_CAMPAIGN_CRM_TEAM,
      delete: CRUD_CAMPAIGN_CRM_TEAM,
    },
  },
  inquiry: {
    entityType: "inquiry",
    idKey: "inquiryId",
    get: getInquiryCrmTeam,
    add: addInquiryCrmTeam,
    update: updateInquiryCrmTeam,
    delete: deleteInquiryCrmTeam,
    endpoints: {
      get: GET_INQUIRY_CRM_TEAM_BY_INQUIRY_ID,
      add: CRUD_INQUIRY_CRM_TEAM,
      update: CRUD_INQUIRY_CRM_TEAM,
      delete: CRUD_INQUIRY_CRM_TEAM,
    },
  },
  prospect: {
    entityType: "prospect",
    idKey: "prospectId",
    get: getProspectCrmTeam,
    add: addProspectCrmTeam,
    update: updateProspectCrmTeam,
    delete: deleteProspectCrmTeam,
    endpoints: {
      get: GET_PROSPECT_CRM_TEAM_BY_PROSPECT_ID,
      add: CRUD_PROSPECT_CRM_TEAM,
      update: CRUD_PROSPECT_CRM_TEAM,
      delete: CRUD_PROSPECT_CRM_TEAM,
    },
  },
  customer: {
    entityType: "customer",
    idKey: "customerId",
    get: getCustomerCrmTeam,
    add: addCustomerCrmTeam,
    update: updateCustomerCrmTeam,
    delete: deleteCustomerCrmTeam,
    endpoints: {
      get: GET_CUSTOMER_CRM_TEAM_BY_CUSTOMER_ID,
      add: CRUD_CUSTOMER_CRM_TEAM,
      update: CRUD_CUSTOMER_CRM_TEAM,
      delete: CRUD_CUSTOMER_CRM_TEAM,
    },
  },
  order: {
    entityType: "order",
    idKey: "orderId",
    get: getOrderCrmTeam,
    add: addOrderCrmTeam,
    update: updateOrderCrmTeam,
    delete: deleteOrderCrmTeam,
    endpoints: {
      get: GET_ORDER_CRM_TEAM_BY_ORDER_ID,
      add: CRUD_ORDER_CRM_TEAM,
      update: CRUD_ORDER_CRM_TEAM,
      delete: CRUD_ORDER_CRM_TEAM,
    },
  },
});

// Proxy to allow property access while resolving lazily
export const CRM_TEAM_API_MAP = new Proxy(
  {},
  {
    get: (_target, prop) => getCrmTeamApiMap()[prop],
  }
);

const CRM_TEAM_FLAG_LIST = [
  { flag: "forOrder", type: "order" },
  { flag: "forContract", type: "contract" },
  { flag: "forAccount", type: "customer-account" },
  { flag: "forContact", type: "contact" },
  { flag: "forOpportunity", type: "opportunity" },
  { flag: "forLead", type: "lead" },
  { flag: "forCampaign", type: "campaign" },
  { flag: "forInquiry", type: "inquiry" },
  { flag: "forProspect", type: "prospect" },
  { flag: "forCustomer", type: "customer" },
];

const CRM_TEAM_ID_KEY_LIST = [
  { key: "orderId", type: "order" },
  { key: "contractId", type: "contract" },
  { key: "customerAccountId", type: "customer-account" },
  { key: "accountId", type: "customer-account" },
  { key: "contactId", type: "contact" },
  { key: "opportunityId", type: "opportunity" },
  { key: "leadId", type: "lead" },
  { key: "campaignId", type: "campaign" },
  { key: "inquiryId", type: "inquiry" },
  { key: "prospectId", type: "prospect" },
  { key: "customerId", type: "customer" },
];

const CRM_TEAM_NAME_ALIASES = {
  account: "customer-account",
  customeraccount: "customer-account",
};

const normalizeCrmTeamEntityString = (str) => {
  const normalized = str.toLowerCase().trim();
  return CRM_TEAM_NAME_ALIASES[normalized] || normalized;
};

const isValidEntityId = (value) =>
  Boolean(value && value !== true && value !== "true");

const resolveFromPropsObject = (props) => {
  if (props?.entityType) {
    return resolveCrmTeamEntity(props.entityType);
  }

  const matchedFlag = CRM_TEAM_FLAG_LIST.find(({ flag }) => Boolean(props[flag]));
  if (matchedFlag) {
    return matchedFlag.type;
  }

  const matchedId = CRM_TEAM_ID_KEY_LIST.find(({ key }) => isValidEntityId(props[key]));
  return matchedId ? matchedId.type : null;
};

/**
 * Resolves the entity name ('contract', 'customer-account', etc.)
 * from props or an entity string.
 */
export const resolveCrmTeamEntity = (propsOrType) => {
  if (!propsOrType) return null;
  if (typeof propsOrType === "string") return normalizeCrmTeamEntityString(propsOrType);
  if (typeof propsOrType === "object") return resolveFromPropsObject(propsOrType);
  return null;
};

/**
 * Returns the exact CRM Team API functions and endpoints for an entity.
 * Prints clear logs indicating exactly what API endpoints are being hit.
 *
 * @param {object|string} propsOrType Component props or entity type string
 * @returns {{ entityType: string, idKey: string, get: Function, add: Function, update: Function, delete: Function, endpoints: object }}
 */
export const getCrmTeamApi = (propsOrType) => {
  const map = getCrmTeamApiMap();
  const entityType = resolveCrmTeamEntity(propsOrType) || "contract";
  const apiConfig = map[entityType] || map.contract;

  // Log which API is being targeted to ensure full developer visibility
  console.log(
    `[CRM Team Service] Target Entity: "${apiConfig.entityType.toUpperCase()}" | ` +
    `GET: ${apiConfig.endpoints.get} | ` +
    `ADD: ${apiConfig.endpoints.add} | ` +
    `UPDATE: ${apiConfig.endpoints.update} | ` +
    `DELETE: ${apiConfig.endpoints.delete}`
  );

  return apiConfig;
};
